/**
 * Created by richard on 7/14/14.
 */
var vouStatementModel = angular.module('vouStatementModel', ['schoolModel']);
vouStatementModel.factory('VouStatementModelFactory', function(ApplicationService, RestService, authServiceFactory, SchoolModelFactory, AbstractModelService){
    var VouStatementModel = function(){
        this.endpoint = "/VouStatement";
        this.primaryKey = "schoolID";
    }
    VouStatementModel.prototype = new SchoolModelFactory();
    VouStatementModel.prototype.parent = SchoolModelFactory.prototype;
    VouStatementModel.prototype.new = function()
    {
        var schoolID = this.getSchoolID();
        var voucher = {schoolID: schoolID, statementDate:'', lastStatementDate:'', statementDateDue:'', totalAmountDue:'', newBalance:'', pastDueAmount:'',
                        CurrentAmountDue:'', NotDueYet:'', lastPaymentDue:'', showMessage:'', timeStamp:'NOW()', Status:'', oldStatement:'', paid:''};
        return (this.data.push(voucher)) - 1;
    }

    return VouStatementModel;
});


vouStatementModel.service('VouStatementModelService', function(VouStatementModelFactory){
    var vouStatementModel = new VouStatementModelFactory();
    return vouStatementModel;
});


